import React, {
  createContext,
  useState,
  ReactNode,
  useEffect,
  useReducer,
} from "react";
import useGetHook from "../../../../customHooks/useGetHook";
import APIS from "../../../../contants/Endpoints";
import { cartItemReducer } from "./cartItemReducer";
import { cartInitialState } from "./cartItemInitial";
import { getApiData } from "../../../../helpers/AxiosInstance";
import { useNavigate } from "react-router-dom";

export const CartContext = createContext<any>(undefined);

export const CartItemProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const navigate = useNavigate();
  const [state, dispatch] = useReducer(
    cartItemReducer,
    cartInitialState,
    undefined
  );
  async function addItemToCart(id: any) {
    if (id) {
      const endPoint = `${APIS.PRODUCT}${id}/`;
      const response = await getApiData(endPoint);
      const data = response.data;

      const previousCart = state?.cartItem || [];
      const existingCartItem: any = previousCart?.find(
        (cartItem: any) => cartItem.id === data.id
      );

      // GST calculation helper
      const calculateGST = (rate: number, quantity: number) => {
        return rate * quantity - (rate * quantity) / 1.1;
      };

      if (existingCartItem && existingCartItem?.id === id) {
        const updatedCartItem = {
          ...existingCartItem,
          quantity: (parseFloat(existingCartItem.quantity) + 1).toFixed(2),
          gst: calculateGST(
            parseFloat(data.rate),
            parseFloat(existingCartItem.quantity) + 1
          ),
          isSelected: true,
        };

        const updatedCart = previousCart.map((item: any) =>
          item.id === existingCartItem.id
            ? updatedCartItem
            : { ...item, isSelected: false }
        );

        dispatch({ type: "addItem", payload: updatedCart });
      } else {
        const newCartItem = {
          id: data.id,
          name: data.name,
          code: data.code,
          rate: data.rate,
          weight: data.weight,
          quantity: 1,
          gst: calculateGST(parseFloat(data.rate), 1),
          isSelected: true,
        };

        const updatedCart = [
          ...previousCart.map((item: any) => ({ ...item, isSelected: false })),
          newCartItem,
        ];

        dispatch({ type: "addItem", payload: updatedCart });
      }
    }
  }
  function cartItemsDelete(value: any) {
    dispatch({ type: "deleteIndividualItem", payload: value });
  }
  function allCartItemsDelete(value: []) {
    dispatch({ type: "deleteItem", payload: value });
  }
  function editItems(id: string, value: any) {
    if (id) {
      const editData = state.cartItem.map((item: any) =>
        item.id === id ? { ...item, ...value } : item
      );
      dispatch({ type: "editItem", payload: editData });
    } else {
      const editData = state.cartItem.map((item: any) => {
        const updatedItem = value.find(
          (updated: any) => updated.id === item.id
        );
        return updatedItem ? { ...item, ...updatedItem } : item;
      });
      dispatch({ type: "editItem", payload: editData });
    }
  }
  async function holdItemToCart(id: any) {
    if (id) {
      const endPoint = `${APIS.ORDER}${id}/`;
      const params: any = {
        payment_status: "hold",
      };
      const response = await getApiData(endPoint, params);
      const cartItems = response?.data?.order_items?.map((item: any) => ({
        id: item.product.id,
        name: item.product.name,
        code: item.code,
        rate: parseFloat(item.rate),
        weight: parseFloat(item.weight),
        quantity: item.quantity ? parseFloat(item.quantity) : 1,
        gst: item?.total_gst,
        isSelected: true,
      }));
      dispatch({ type: "addItem", payload: cartItems, orderId: id });
      navigate("/pos-screen");
    }
  }
  return (
    <CartContext.Provider
      value={{
        addItemToCart,
        state,
        allCartItemsDelete,
        cartItemsDelete,
        editItems,
        holdItemToCart,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
